import React from "react";
import { OrderDocument } from "@/models";
import { InfoIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { brand } from "@/lib/brand";

interface DocumentHeaderProps {
  document: OrderDocument;
  orderId: number;
  orderDate: string;
  propertyAddress: string;
  ipAddress?: string | null;
  associationName?: string;
  processedAt?: string | null;
  downloadedAt?: string | null;
  isOutputHeader?: boolean;
}

export const DocumentHeader: React.FC<DocumentHeaderProps> = ({
  document,
  orderId,
  orderDate,
  propertyAddress,
  ipAddress,
  associationName,
  processedAt,
  downloadedAt,
  isOutputHeader = false,
}) => {
  const formatTimestamp = (timestamp?: string | null): string => {
    if (!timestamp) return "Not set";
    try {
      const date = new Date(timestamp);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString();
      }
    } catch (error) {
      console.error("Error formatting timestamp:", error);
    }
    return "Invalid date";
  };

  return (
    <>
      <div className="bg-white border rounded-lg p-6 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h1 className="font-bold mb-2 text-base">
              {isOutputHeader ? "Document Output" : document.document.name}
            </h1>
            <p className="text-gray-600">Order #{orderId}</p>
            {ipAddress && (
              <p className="text-gray-500 text-sm mt-1">IP: {ipAddress}</p>
            )}
          </div>

          <div className="text-center">
            <p className="text-gray-600 mb-2">{propertyAddress}</p>
            {/* Processing Timestamps */}
            <div className="space-y-1 text-sm">
              <div>
                <span className="text-gray-500">Last Processed: </span>
                <span className="text-gray-700">
                  {formatTimestamp(processedAt)}
                </span>
              </div>
              <div>
                <span className="text-gray-500">Last Downloaded: </span>
                <span className="text-gray-700">
                  {formatTimestamp(downloadedAt)}
                </span>
              </div>
            </div>
          </div>

          <div className="text-right">
            <p className="text-gray-600 mb-2">Issuance Date</p>
            <p className="text-lg">
              {new Date(orderDate).toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>

    </>
  );
};
